var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-layout', {
    attrs: {
      "px-0": "",
      "py-2": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-card', {
    staticClass: "detailPanel",
    attrs: {
      "to": {
        name: 'callDetail',
        params: {
          id: _vm.activeCallId
        }
      },
      "color": "yellow darken-2",
      "tile": ""
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("business")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.details')) + "\n          ")])], 1)], 1)], 1), _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-card', {
    staticClass: "locationPanel",
    attrs: {
      "to": {
        name: 'location'
      },
      "color": "indigo darken-2",
      "tile": ""
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("map")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("Location")])], 1)], 1)], 1), _vm.callDetail.status === 'Arrival Completed' || _vm.callDetail.status === 'Departed' ? _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-card', {
    staticClass: "powraPanel",
    attrs: {
      "color": "green darken-4",
      "tile": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.confirmEditPowra();
      }
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("warning")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.powra')) + "\n          ")])], 1)], 1)], 1) : _vm._e(), _vm.callDetail.status === 'Travelling' ? _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-card', {
    staticClass: "travellingPanel",
    attrs: {
      "color": _vm.callDetail.status === 'Travelling' ? 'blue darken-2' : 'grey darken-2',
      "tile": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.checkProximity();
      }
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [this.arrivalProgress ? _c('v-progress-circular', {
    attrs: {
      "size": 72,
      "color": "white",
      "indeterminate": "",
      "width": "6"
    }
  }) : _c('div', [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("highlight_off")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n              " + _vm._s(_vm.$vuetify.t('$vuetify.calls.arrived')) + "\n            ")])], 1)], 1)], 1)], 1) : _vm._e(), _vm.callDetail.status === 'Arrived' ? _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-card', {
    class: _vm.callDetail.status === 'Arrived' ? 'blue darken-2' : '',
    attrs: {
      "color": "blue darken-2",
      "tile": ""
    },
    on: {
      "click": function click($event) {
        return _vm.arrivalProcessBegin();
      }
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("highlight_off")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.arrivalComplete')) + "\n          ")])], 1)], 1)], 1) : _vm._e(), _vm.callDetail.status === 'Arrival Completed' || _vm.callDetail.status === 'Departed' ? _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-card', {
    class: _vm.callDetail.status === 'Arrival Completed' ? 'completePanel' : '',
    attrs: {
      "to": {
        path: '/form/engineer-worksheet'
      },
      "color": "cyan darken-2",
      "tile": ""
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("book")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.worksheet')) + "\n          ")])], 1)], 1)], 1) : _vm._e(), _vm.callDetail.status === 'Arrival Completed' || _vm.callDetail.status === 'Departed' ? _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-card', {
    class: _vm.callDetail.status === 'Arrival Completed' ? 'completePanel' : '',
    attrs: {
      "to": {
        name: 'callComplete',
        params: {
          id: _vm.activeCallId
        }
      },
      "color": "green darken-2",
      "tile": ""
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("highlight_off")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.complete')) + "\n          ")])], 1)], 1)], 1) : _vm._e(), _vm.callDetail.status === 'Arrival Completed' || _vm.callDetail.status === 'Departed' ? _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": {
        name: 'media'
      },
      "color": "purple darken-2",
      "tile": ""
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("camera")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.media')) + "\n          ")])], 1)], 1)], 1) : _vm._e(), _vm.callDetail.status === 'Arrival Completed' || _vm.callDetail.status === 'Departed' ? _c('v-flex', {
    attrs: {
      "md6": "",
      "xs12": "",
      "mb-2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": {
        name: 'scans'
      },
      "color": "red darken-2",
      "tile": ""
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("description")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.documents')) + "\n          ")])], 1)], 1)], 1) : _vm._e(), _c('v-flex', {
    attrs: {
      "md6": "",
      "x12": "",
      "mb-2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "to": "/forms",
      "color": "orange darken-1",
      "tile": ""
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("dvr")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n            Other Forms\n          ")])], 1)], 1)], 1), _c('v-flex', {
    attrs: {
      "md12": "",
      "xs12": ""
    }
  }, [_vm.callDetail.status !== 'Departed' ? _c('v-card', {
    staticClass: "resetPanel",
    attrs: {
      "color": "black darken-2",
      "tile": ""
    },
    nativeOn: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_c('v-card-text', {
    staticClass: "white--text text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "x-large": ""
    }
  }, [_vm._v("highlight_off")]), _c('div', {
    staticClass: "headline text-xs-center"
  }, [_vm._v("\n            " + _vm._s(_vm.$vuetify.t('$vuetify.calls.reset')) + "\n          ")])], 1)], 1) : _vm._e()], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.resetCallHeader')) + "\n      ")]), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.resetCallBody')) + "\n      ")]), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.app.cancel')) + "\n        ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": _vm.confirmReset
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.resetCallConfirm')) + "\n        ")])], 1)], 1)], 1), _c('proximity-dialog', {
    ref: "proximityDialog",
    attrs: {
      "distance-to-site": this.distanceToSite
    },
    on: {
      "accept-proximity-warning": _vm.confirmProximity
    }
  }), _c('edit-powra-dialog', {
    ref: "editPowraDialog",
    on: {
      "accept-edit-powra-warning": _vm.setPowraMode
    }
  }), _c('contract-notes', {
    attrs: {
      "notes": _vm.callDetail.contract_note,
      "show": _vm.contractNotesDialog
    },
    on: {
      "aborted": function aborted($event) {
        return _vm.visitAborted(_vm.callDetail.id);
      },
      "back": function back($event) {
        _vm.contractNotesDialog = false;
      },
      "confirmed": function confirmed($event) {
        return _vm.contractNotesConfirmed(_vm.callDetail.id);
      }
    }
  }), _c('sign-in-method', {
    attrs: {
      "method": _vm.callDetail.sign_in_method,
      "link": _vm.callDetail.sign_in_link,
      "show": _vm.signInMethodDialog
    },
    on: {
      "aborted": function aborted($event) {
        return _vm.visitAborted(_vm.callDetail.id);
      },
      "back": function back($event) {
        _vm.callDetail.contract_note ? _vm.contractNotesDialog = true : '', _vm.signInMethodDialog = false;
      },
      "confirmed": function confirmed($event) {
        return _vm.signInMethodConfirmed(_vm.callDetail.id);
      }
    }
  }), _c('work-assessment', {
    attrs: {
      "show": _vm.workAssessmentDialog
    },
    on: {
      "aborted": function aborted($event) {
        return _vm.visitAborted(_vm.callDetail.id);
      },
      "back": function back($event) {
        ;
        _vm.signInMethodDialog = true, _vm.workAssessmentDialog = false;
      },
      "confirmed": function confirmed($event) {
        var _vm2;
        return (_vm2 = _vm).workAssessmentConfirmed.apply(_vm2, [_vm.callDetail.id].concat(Array.prototype.slice.call(arguments)));
      },
      "close": function close($event) {
        _vm.workAssessmentDialog = false;
      }
    }
  }), _c('pre-work-analysis', {
    attrs: {
      "duration": _vm.callDetail.estimated_duration_minutes,
      "show": _vm.preWorkAnalysisDialog
    },
    on: {
      "aborted": function aborted($event) {
        return _vm.visitAborted(_vm.callDetail.id);
      },
      "back": function back($event) {
        ;
        _vm.workAssessmentDialog = true, _vm.preWorkAnalysisDialog = false;
      },
      "confirmed": function confirmed($event) {
        var _vm3;
        return (_vm3 = _vm).preWorkAnalysisConfirmed.apply(_vm3, [_vm.callDetail.id].concat(Array.prototype.slice.call(arguments)));
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }